// src/components/SmartFlow/nodes/EndNode.jsx

import React from 'react';
import BaseNode from './base/BaseNode';

/**
 * End Node Component
 * Marks the end of a workflow
 */
const EndNode = ({ data, selected }) => {
  const config = data.config || {};
  const status = config.status || 'Workflow completed';

  return (
    <BaseNode
      data={data}
      icon="bi-check-circle"
      color="#95a5a6"
      label="End"
      subtitle={status}
      hasHandles={{ top: true, bottom: false }}
      selected={selected}
    />
  );
};

export default EndNode;
